import React from 'react';
import FooterIcon from '../../svg/FooterIcon';
import UGEIcon from '../../svg/CircleBadge';

const Footer = () => (
  <footer className="bg-gray-900">
    <div className="md:w-1/2 mx-auto px-4 sm:px-6 lg:pt-16 lg:pb-8 ">
      <div className="hidden md:flex justify-center items-center">
        <div className="xl:col-span-1 mx-auto">
          <div className=" mx-auto flex w-32">
            <FooterIcon />
          </div>
        </div>
        <div className="mt-12 mx-auto gap-2 xl:mt-0">
          <div className="text-center  md:gap-2">
            <div>
              <h4 className="text-center  text-sm leading-5 font-semibold tracking-wider text-blue-200 uppercase">
                Get in Touch
              </h4>
              <p className="text-xl font-medium text-white">1659 Achieva Way, Dunedin, FL 3469</p>

              <dd className="flex justify-center">
                <svg
                  className="flex-shrink-0 h-6 w-6 text-gray-400"
                  fill="none"
                  stroke="#8bc540"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                >
                  <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a className="ml-3 text-xl font-medium text-secondary" href="tel:8883417735">
                  +1 (888) 341-7735
                </a>
              </dd>
              <dd className="mt-3 flex justify-center">
                <svg
                  className="flex-shrink-0 h-6 w-6 text-gray-400"
                  stroke="#8bc540"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                <a
                  className="text-xl ml-3 font-medium text-secondary"
                  href="mailto:Marketing@ConsultFGC.com"
                >
                  marketing@consultfgc.com
                </a>
              </dd>
            </div>
          </div>
        </div>
        <div className="xl:col-span-1 mx-auto">
          <div className="ml-2 mx-auto flex w-32">
            <UGEIcon />
          </div>
        </div>
      </div>

      <div className="mobile md:hidden items-center">
        <div class="pt-10 flex justify-center">
          <div className="xl:col-span-1 ">
            <div className=" flex w-32">
              <FooterIcon />
            </div>
          </div>
          <div className="xl:col-span-1 ">
            <div className="ml-2 flex w-32">
              <UGEIcon />
            </div>
          </div>
        </div>

        <div className="mt-12 mx-auto gap-2 xl:mt-0">
          <div className="text-center  md:gap-2">
            <div>
              <h4 className="text-center  text-sm leading-5 font-semibold tracking-wider text-blue-200 uppercase">
                Get in Touch
              </h4>
              <p className="text-xl font-medium text-white">1659 Achieva Way, Dunedin, FL 3469</p>

              <dd className="flex justify-center">
                <svg
                  className="flex-shrink-0 h-6 w-6 text-gray-400"
                  fill="none"
                  stroke="#8bc540"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                >
                  <path d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a className="ml-3 text-xl font-medium text-secondary" href="tel:8883417735">
                  +1 (888) 341-7735
                </a>
              </dd>
              <dd className="mt-3 flex justify-center">
                <svg
                  className="flex-shrink-0 h-6 w-6 text-gray-400"
                  stroke="#8bc540"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                <a
                  className="text-xl ml-3 font-medium text-secondary"
                  href="mailto:Marketing@ConsultFGC.com"
                >
                  marketing@consultfgc.com
                </a>
              </dd>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class=" bg-black">
      <div class="md:w-1/2 mx-auto mt-8 py-2 bg-black px-4 md:px-0  flex  justify-around">
        <div class=" pt-5 ml-6 flex order-1 md:order-2">
          <a
            href="https://www.facebook.com/ConsultFGC/"
            target="_blank"
            class="-mt-0.5 text-white hover:text-gray-500"
          >
            <span class="sr-only">Facebook</span>
            <svg class="h-7 w-7" fill="currentColor" viewBox="0 0 24 24">
              <path
                fill-rule="evenodd"
                d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                clip-rule="evenodd"
              />
            </svg>
          </a>{' '}
          <a
            href="https://www.linkedin.com/company/consult-fgc/"
            target="_blank"
            class="ml-6 text-white hover:text-gray-500"
          >
            <span class="sr-only">LinkedIn</span>
            <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
              <path
                fill-rule="evenodd"
                d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2 16h-2v-6h2v6zm-1-6.891c-.607 0-1.1-.496-1.1-1.109 0-.614.492-1.109 1.1-1.109s1.1.497 1.1 1.109c0 .613-.493 1.109-1.1 1.109zm8 6.891h-1.998v-2.861c0-1.881-2.002-1.722-2.002 0v2.861h-2v-6h2v1.093c.872-1.616 4-1.736 4 1.548v3.359z"
                clip-rule="evenodd"
              />
            </svg>
          </a>
        </div>
        <p className="text-xs md:text-base text-white text-center">
          &copy; {new Date().getFullYear()} ConsultFGC, Inc. All rights reserved.{' '}
          <a href="/capabilities">
            <span> GSA Capabilities</span>
          </a>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
